module.exports = __webpack_public_path__ + "media/about.c6e43646.mp4";